import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a26c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scenario" }
const _hoisted_2 = { class: "scenario-category" }
const _hoisted_3 = { class: "scenario-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.scenario.category.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.scenario.text), 1)
  ]))
}